import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Fortuna Markets';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/panel';
export const PUBLIC_RECAPTCHA_KEY = '6Lecm04cAAAAAK0MskJPM5OISZZokIaiyN5tQA0K';

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR
};

const langInRoute = window.location.pathname.split("/")[1];
export const AUTH_PREFIX_PATH = "/" + (["en", "fa"].includes(langInRoute) ? langInRoute : THEME_CONFIG.locale);